import React, { useState, useEffect, createContext, useContext } from "react"

const WindowContext = createContext()

const WindowProvider = ({ children }) => {
  const [isBrowser, setIsBrowser] = useState(false)

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsBrowser(true)
    }
  }, [])

  return (
    <WindowContext.Provider value={{ isBrowser }}>
      {children}
    </WindowContext.Provider>
  )
}

const useWindow = () => useContext(WindowContext)
export { useWindow }
export default WindowProvider
